import { FormControl, FormLabel, Grid, Slider, Typography, TextField, IconButton, Stack } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import { useEffect, useState } from 'react';

const EdadHijo = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const [edad, setEdad] = useState(promptData.edad || 1);

    useEffect(() => {
        setPromptData((prevData: any) => ({
            ...prevData,
            edad: edad,
        }));
    }, [edad, setPromptData]);

    const handleSliderChange = (event: any, newValue: any) => {
        setEdad(newValue);
        console.log(promptData);
        
    };

    const handleInputChange = (event: any) => {
        const newValue = event.target.value === '' ? '' : Number(event.target.value);
        setEdad(newValue);
    };

    const handleIncrement = () => {
        setEdad((prev: any) => Math.min(prev + 1, 12));
    };

    const handleDecrement = () => {
        setEdad((prev: any) => Math.max(prev - 1, 1));
    };

    return (
        <Grid sx={{ mb: 3 }} >
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Edad del hijo *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                    Selecciona la edad del hijo que participará de la actividad
                </FormLabel>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2} >
                    {/* Slider en la parte izquierda */}
                    <Grid item xs={6}>
                        <Slider
                            value={typeof edad === 'number' ? edad : 1}
                            onChange={handleSliderChange}
                            step={1}
                            min={1}
                            max={12}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} años`}
                            aria-labelledby="edad-slider"
                            sx={{
                                color: '#336B87',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    {/* Contador en la parte derecha */}
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                        <IconButton onClick={handleDecrement} disabled={edad <= 1}>
                            <Remove />
                        </IconButton>

                        <TextField
                            variant="standard"
                            value={edad}
                            onChange={handleInputChange}
                            inputProps={{
                                step: 1,
                                min: 1,
                                max: 12,
                                type: 'text',
                                style: {
                                    textAlign: 'center',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                },
                            }}
                            sx={{ width: 40 }}
                        />

                        <IconButton onClick={handleIncrement} disabled={edad >= 12}>
                            <Add />
                        </IconButton>
                    </Stack>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default EdadHijo;